import { render, staticRenderFns } from "./occurrence.vue?vue&type=template&id=14976f27&"
import script from "./occurrence.vue?vue&type=script&lang=js&"
export * from "./occurrence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports